import { useAppSelector } from '@app/store';
import { selectSettingsAnimations } from '@app/store/slices/settings';

export const useAnimationsEnabled = () => useAppSelector(selectSettingsAnimations);
